import type { GetCustomerDataParams } from './getCustomerData';
import { getCustomerData } from './getCustomerData';

export const sendCustomerData = (customerDataParams: GetCustomerDataParams) => {
  // eslint-disable-next-line new-cap -- Genesys preset naming
  window.Genesys?.('command', 'Database.set', {
    messaging: {
      customAttributes: getCustomerData(customerDataParams),
    },
  });
};
